
import { constantConfig } from 'web-common';
import { AboutAnchorEnum } from '../page/AboutUs/config';

const { ModuleTypeEnum, WEBSITE_PATHS } = constantConfig;

// 菜单属性
export interface MenuItemVo {
    menuName: string;                           // 导航名称，同name的值一样
    path: string;                               // 跳转路由
    menuId?: string;                            // 导航id，动态的二级菜单必须带menuId
    englishName?: string;                       // 菜单英文名称
    children?: MenuItemVo[];                    // 子菜单
    module?: constantConfig.ModuleTypeEnum;     // 模块名称
    isAsyncChildrenMenu?: boolean;              // 是否有配置子类动态菜单，如果是true，就要请求数据，并添加到children里,必须和module属性一起使用 
    isOutLink?: boolean;                        // 是否外部链接
}



// 主菜单导航配置
export const MENUS: MenuItemVo[] = [
    { 
        menuName: '首页',
        englishName: 'HOME',
        path: WEBSITE_PATHS.home,
    },
    { 
        menuName: '关于',
        englishName: 'ABOUT US',
        path: WEBSITE_PATHS.aboutUs,
        children: [
            { menuName: '公司简介', path: `${WEBSITE_PATHS.aboutUs}?anchor=${AboutAnchorEnum.PROFILE}` }, 
            { menuName: '企业文化', path: `${WEBSITE_PATHS.aboutUs}?anchor=${AboutAnchorEnum.CULTURE}` }, 
            { menuName: '管理团队', path:`${WEBSITE_PATHS.aboutUs}?anchor=${AboutAnchorEnum.TEAM}` },
            { menuName: '天府匠芯', path: WEBSITE_PATHS.aboutUsPublicize },
        ] 
    },
    { 
        menuName: '作品', 
        englishName: 'PROJECTS',
        path: WEBSITE_PATHS.product,
        module: ModuleTypeEnum.PROJECT,
        isAsyncChildrenMenu: true,
        children: [] 
    },
    { 
        menuName: '服务', 
        englishName: 'SERVICES',
        path: WEBSITE_PATHS.service,
        children: [
            { menuName: '大咨询', path: WEBSITE_PATHS.service, }, 
            { menuName: '大设计', path: WEBSITE_PATHS.service, }, 
            { menuName: '大管理', path: WEBSITE_PATHS.service, }, 
        ] 
    },
    { 
        menuName: '动态', 
        englishName: 'NEWS',
        path: WEBSITE_PATHS.news,
        module: ModuleTypeEnum.NEWS,
        isAsyncChildrenMenu: true,
        children: [] 
    },
    { 
        menuName: '招聘', 
        englishName: 'JOIN US',
        isOutLink: true,
        path: WEBSITE_PATHS.joinUs
    },
    { 
        menuName: '阅读', 
        englishName: 'READINGS',
        path: WEBSITE_PATHS.read,
        children: [
            { menuName: '基准之道', path: WEBSITE_PATHS.periodical }, 
            { menuName: '视觉美学', path: WEBSITE_PATHS.aesthetice },
        ] 
    },
    { 
        menuName: '联系', 
        englishName: 'CONTACTS',
        path: WEBSITE_PATHS.contactUs,
        children: [
            { menuName: '联系我们', path: WEBSITE_PATHS.contactUs, }, 
            { menuName: '通知公告', path: WEBSITE_PATHS.noticeList, },
            { menuName: '贪腐解聘查询', path: WEBSITE_PATHS.integrityInquiry, },
        ]
    },
];